/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The method in which the client was input into the customer's account.
 * @export
 * @enum {string}
 */
export enum InputMethod {
	Default = 'default',
	SharefileContact = 'sharefile_contact',
	Import = 'import',
	Integration = 'integration',
}

export function InputMethodFromJSON(json: any): InputMethod {
	return InputMethodFromJSONTyped(json, false);
}

export function InputMethodFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): InputMethod {
	return json as InputMethod;
}

export function InputMethodToJSON(value?: InputMethod | null): any {
	return value as any;
}
